import angular from 'angular';
 
class FooterComponent {
}

export default angular.module('directives.footer', [])
    .component('footer', {
        template: require('./footer.html'),
        controller: FooterComponent
    })
    .name;



// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js